import { Fragment } from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';

export interface BreadcrumbItem {
  label: string;
  to?: string;
}

export function Breadcrumbs({ items }: { items: BreadcrumbItem[] }) {
  if (!items.length) return null;
  if (items.length === 1 && !items[0]!.to) return null;
  return (
    <nav aria-label="Breadcrumb" className="min-w-0">
      <ol className="flex min-w-0 items-center gap-1 text-[11px] text-ink-muted">
        {items.map((item, idx) => {
          const isLast = idx === items.length - 1;
          return (
            <Fragment key={`${item.label}-${idx}`}>
              <li className="min-w-0 truncate">
                {item.to && !isLast ? (
                  <Link
                    to={item.to}
                    className="truncate rounded px-0.5 hover:text-ink-primary hover:underline focus:outline-none focus:ring-2 focus:ring-accent-500"
                  >
                    {item.label}
                  </Link>
                ) : (
                  <span
                    aria-current={isLast ? 'page' : undefined}
                    className={isLast ? 'truncate font-medium text-ink-secondary' : 'truncate'}
                  >
                    {item.label}
                  </span>
                )}
              </li>
              {!isLast && (
                <li aria-hidden className="shrink-0">
                  <ChevronRight className="h-3 w-3 text-ink-muted/60" />
                </li>
              )}
            </Fragment>
          );
        })}
      </ol>
    </nav>
  );
}
